import React from 'react'

const SignUp = () => {
  return (
    <h1>SignUp</h1>
  )
}

export default SignUp